"use client"

import { StarHalf } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `StarHalfIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const StarHalfIcon = component(Icon)({ as: StarHalf })
